import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0";

/* Animated rocket SVG */
const RocketSVG = () => (
  <svg viewBox="0 0 160 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 120, height: "auto", animation: "floatY 2.5s ease-in-out infinite" }}>
    <ellipse cx="80" cy="85" rx="30" ry="50" fill={CORAL} stroke={NAVY} strokeWidth="3" />
    <polygon points="80,20 55,70 105,70" fill={YELLOW} stroke={NAVY} strokeWidth="2" />
    <circle cx="80" cy="85" r="14" fill="#C8F5FF" stroke={NAVY} strokeWidth="2" />
    <rect x="50" y="120" width="60" height="18" rx="5" fill="#FF9F1C" stroke={NAVY} strokeWidth="2" />
    <polygon points="55,138 40,165 55,155" fill={CORAL} stroke={NAVY} strokeWidth="2" />
    <polygon points="105,138 120,165 105,155" fill={CORAL} stroke={NAVY} strokeWidth="2" />
    {/* Flame */}
    <ellipse cx="80" cy="158" rx="16" ry="28" fill={YELLOW} style={{ animation: "pulse 0.6s ease-in-out infinite" }} />
    <ellipse cx="80" cy="158" rx="8" ry="16" fill="#fff" opacity="0.7" />
    <text x="65" y="170" fontSize="12">🔥</text>
  </svg>
);

const AdmissionsBanner = ({ phone, onNavigate }) => (
  <AnimatedSection id="admissions" sx={{ backgroundColor: TEAL, py: { xs: 9, md: 11 }, position: "relative", overflow: "hidden" }}>
    {/* Decorative shapes */}
    {[{ top: "-40px", left: "-40px", s: 140, c: CORAL }, { bottom: "-50px", right: "-50px", s: 180, c: YELLOW }, { top: "30%", right: "8%", s: 80, c: "rgba(27,31,59,0.15)" }].map((sh, i) => (
      <Box key={i} sx={{ position: "absolute", top: sh.top, bottom: sh.bottom, left: sh.left, right: sh.right, width: sh.s, height: sh.s, borderRadius: "50%", backgroundColor: sh.c, border: `3px solid ${NAVY}` }} />
    ))}

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={7}>
          <Box sx={{ display: "inline-block", px: 2, py: 0.5, mb: 2, borderRadius: "8px", border: `2px solid ${NAVY}`, backgroundColor: YELLOW, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.78rem", letterSpacing: "0.1em", color: NAVY, textTransform: "uppercase" }}>
            Admissions Open 2026–27
          </Box>
          <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: { xs: "2.2rem", sm: "2.8rem", md: "3.4rem" }, color: NAVY, lineHeight: 1.15, mb: 2 }}>
            A Great Place to Learn, Grow & Succeed 🌟
          </Typography>
          <Typography sx={{ color: NAVY, fontWeight: 700, fontSize: { xs: "1rem", md: "1.1rem" }, lineHeight: 1.8, mb: 4, opacity: 0.8, maxWidth: 560 }}>
            Give your child a positive learning environment where they can learn new things, discover their talents and grow with confidence. Apply now for the 2026-27 academic year.
          </Typography>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Button onClick={() => onNavigate("contact")} sx={{ px: 4, py: 1.5, fontSize: "1rem", backgroundColor: NAVY, color: YELLOW, border: `2.5px solid ${NAVY}`, boxShadow: `4px 4px 0 ${NAVY}`, borderRadius: "12px", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 800, "&:hover": { backgroundColor: "#2E3461", transform: "translate(-2px,-2px)", boxShadow: `6px 6px 0 ${NAVY}` } }}>
              Apply Now 🎒
            </Button>
            <Button component="a" href={`tel:+91${phone}`} sx={{ px: 4, py: 1.5, fontSize: "1rem", backgroundColor: CORAL, color: "#fff", border: `2.5px solid ${NAVY}`, boxShadow: `4px 4px 0 ${NAVY}`, borderRadius: "12px", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 800, "&:hover": { backgroundColor: "#FF8080", transform: "translate(-2px,-2px)" } }}>
              📞 Call Us
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={5} sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ textAlign: "center" }}>
            <RocketSVG />
            <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "center", maxWidth: 260, mx: "auto" }}>
              {["CBSE ✓", "State Board ✓", "Primary ✓", "High School ✓"].map((t) => (
                <Box key={t} sx={{ px: 2, py: 0.5, borderRadius: "8px", border: `2px solid ${NAVY}`, backgroundColor: "#fff", fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.78rem", color: NAVY }}>
                  {t}
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </AnimatedSection>
);

export default AdmissionsBanner;
